// =============================================================================
// Styles
// =============================================================================

// `--overflow-scroll-gutter` is room around the items for their focus
// indicators, which the scroller would otherwise clip. It defaults to the
// standard outset focus ring (`outline-2 outline-offset-2`). Set it on the
// container for wider indicators.

/**
 * For the element wrapping the scroller and its `OverflowScrollButtons`. It
 * positions the buttons, and pulls the scroller out by its gutter so the items
 * line up with the content around them.
 */
export const overflowScrollContainerStyles = [
  "relative",
  "min-w-0",
  "mx-[calc(var(--overflow-scroll-gutter,0.25rem)*-1)]"
]

/**
 * For the scroller. It scrolls horizontally with a hidden scrollbar, and fades
 * out at each edge with more content. Vertical overflow is clipped, so add
 * vertical padding when the items have an outset focus ring.
 */
export const overflowScrollStyles = [
  "overflow-x-auto overscroll-x-contain",
  "px-[var(--overflow-scroll-gutter,0.25rem)]",
  "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
  // The fade is fully transparent under the scroll button, so the button
  // reads on any background, and wide enough to always cover some of a hidden
  // item
  "[--overflow-scroll-button-size:1.5rem] [--overflow-scroll-fade-size:3.5rem]",
  "[--overflow-scroll-fade-left:black] [--overflow-scroll-fade-right:black]",
  // Prevent focus indicators from being clipped by fades on scroll
  "scroll-px-[calc(var(--overflow-scroll-fade-size)+var(--overflow-scroll-gutter,0.25rem))]",
  "data-[overflow-left]:[--overflow-scroll-fade-left:transparent] data-[overflow-right]:[--overflow-scroll-fade-right:transparent]",
  "[mask-image:linear-gradient(to_right,var(--overflow-scroll-fade-left),var(--overflow-scroll-fade-left)_var(--overflow-scroll-button-size),black_var(--overflow-scroll-fade-size),black_calc(100%_-_var(--overflow-scroll-fade-size)),var(--overflow-scroll-fade-right)_calc(100%_-_var(--overflow-scroll-button-size)),var(--overflow-scroll-fade-right))]"
]
